import { type AutopaySettings, type AutopaySettingsRaw } from "@/redux/slices/user-slice";

export function adaptAutopaySettings(raw: AutopaySettingsRaw): AutopaySettings {
  return {
    id: raw.id,
    userId: raw.user_id,
    cardId: raw.card_id,
    currency: raw.currency,
    threshold: Number(raw.threshold),
    amount: Number(raw.topup_amount),
    enabled: Boolean(raw.is_enabled),
    createdAt: new Date(raw.created_at * 1000),
    updatedAt: new Date(raw.updated_at * 1000),
    enabledAbPackages:  Boolean(raw.is_enabled_ab_packages),
    wasEnabled: raw.is_was_enabled,
  };
}